class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.querySelector('.filter-wrapper-main').classList.add('disabled');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      if (event?.target.classList.contains('filter__price_change')) {
        const params = searchParams.split('&');
        const result = {};

        params.forEach((param) => {
          const [key, value] = param.split('=');
          result[key] = value;
        });

        const currentUrlParams = new URLSearchParams(window.location.search);
        const currentGtePrice = currentUrlParams.get('filter.v.price.gte');
        const currentLtePrice = currentUrlParams.get('filter.v.price.lte');

        let updateParams = false;

        if (
          result['filter.v.price.gte'] &&
          currentLtePrice !== result['filter.v.price.lte'] &&
          currentGtePrice !== result['filter.v.price.gte']
        ) {
          updateParams = true;
        }

        if (updateParams) {
          searchParams = searchParams
            .replace(/filter\.v\.price\.gte=\d+/, 'filter.v.price.gte=0')
            .replace(/filter\.v\.price\.lte=\d+/, `filter.v.price.lte=${result['filter.v.price.gte']}`);
        } else {
          searchParams = searchParams
            .replace(/filter\.v\.price\.gte=\d+/, 'filter.v.price.gte=0')
            .replace(/filter\.v\.price\.lte=\d+/, `filter.v.price.lte=${result['filter.v.price.gte']}`);
        }
      } else if (document.querySelector('.price-range-filter-remove')) {
        const currentParams = new URLSearchParams(window.location.search);
        const currentLte = currentParams.get('filter.v.price.lte');
        const currentGte = currentParams.get('filter.v.price.gte');
        const newSearchParams = new URLSearchParams(searchParams);

        newSearchParams.set('filter.v.price.lte', currentLte);
        newSearchParams.set('filter.v.price.gte', currentGte);
        searchParams = newSearchParams.toString();
      } else {
        searchParams = searchParams
          .replace(/filter\.v\.price\.gte=\d+/, 'filter.v.price.gte=')
          .replace(/&filter\.v\.price\.[^&]+/g, '');
      }

      console.log(searchParams);
      console.log(event?.target);
      if (event?.target === undefined && searchParams) {
        searchParams = '';
        window.mainPriceRangeReset(true);
      } else if (event?.target.classList.contains('facet-filters__sort')) {
        window.mainPriceRangeReset();
      }

      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        window.updatePriceRange();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    window.updatePriceRange();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      
      containerDesktop.classList.remove('loading');
    }

    // Update mobile filter button text with current product count
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const mobileFilterButtons = document.querySelectorAll('close-filter[type="button"]');
    mobileFilterButtons.forEach((button) => {
      // Extract the current product count from the rendered HTML
      const productCountElement = parsedHTML.getElementById('ProductCount');
      if (productCountElement) {
        const countText = productCountElement.textContent.trim();
        // Extract the first number from the product count text (this is the filtered count)
        const countMatch = countText.match(/(\d+)/);
        if (countMatch) {
          const productCount = countMatch[1];
          // Update the button text to show the current filtered count
          button.innerHTML = `See ${productCount} Results`;
        }
      }
    });

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    document.querySelector('.filter-wrapper-main').classList.remove('disabled');
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event?.target.closest('form')?.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class CustomPriceRange extends HTMLElement {
  constructor() {
    super();
    this.rangeSliderPrice();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('input', this.updateTooltip.bind(this));
    });
    this.setMinAndMaxValues();
    const numberS = this.querySelectorAll('input[type=number]');
    let value1 = numberS[0].value;
    let value2 = numberS[1].value;

    this.updateDisplay(value1, value2);
    this.initTooltips();
  }

  initTooltips() {
    const rangeInputs = this.querySelectorAll('input[type=range]');
    const minTooltip = this.querySelector('.min-tooltip .tooltip-value');
    const maxTooltip = this.querySelector('.max-tooltip .tooltip-value');

    if (minTooltip) minTooltip.textContent = rangeInputs[0].value;
    if (maxTooltip) maxTooltip.textContent = rangeInputs[1].value;

    this.positionTooltips();
  }

  updateTooltip(event) {
    const input = event.target;
    const isMin = input.classList.contains('filter__price_min');
    const tooltipSelector = isMin ? '.min-tooltip .tooltip-value' : '.max-tooltip .tooltip-value';
    const tooltip = this.querySelector(tooltipSelector);

    if (tooltip) {
      tooltip.textContent = input.value;
      this.positionTooltips();
    }
  }

  positionTooltips() {
    const rangeInputs = this.querySelectorAll('input[type=range]');
    const minInput = rangeInputs[0];
    const maxInput = rangeInputs[1];
    const minTooltip = this.querySelector('.min-tooltip');
    const maxTooltip = this.querySelector('.max-tooltip');
    const container = this.querySelector('.facets__price--slide');

    if (minTooltip && maxTooltip && container) {
      const containerWidth = container.clientWidth;
      const maxValue = parseInt(minInput.max);

      // Calculate positions as percentages of the slider width
      const minPosition = (parseInt(minInput.value) / maxValue) * 100;
      const maxPosition = (parseInt(maxInput.value) / maxValue) * 100;

      // Position tooltips
      minTooltip.style.left = `calc(${minPosition}% - 20px)`;
      maxTooltip.style.left = `calc(${maxPosition}% - 20px)`;
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    // if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  rangeSliderPrice() {
    var rangeS = this.querySelectorAll('input[type=range]'),
      numberS = this.querySelectorAll('input[type=number]');

    rangeS.forEach((element) => {
      element.oninput = () => {
        rangeS[1].value = rangeS[1].max;
        var slide1 = parseFloat(rangeS[0].value),
          slide2 = parseFloat(rangeS[1].value);

        if (slide1 > slide2) {
          [slide1, slide2] = [slide2, slide1];
        }

        numberS[0].value = slide1;
        numberS[1].value = slide2;

        this.updateDisplay(numberS[0].value, numberS[1].value);
        this.updateTooltip({ target: element });
      };
    });

    numberS.forEach((element) => {
      element.oninput = () => {
        var number1 = parseFloat(numberS[0].value),
          checkValue1 = number1 != number1,
          number2 = parseFloat(numberS[1].value),
          checkValue2 = number2 != number2;

        if (!checkValue1) {
          rangeS[0].value = number1;
        }

        if (!checkValue2) {
          rangeS[1].value = number2;
        }

        if (number1 > number2) {
          this.updateDisplay(number2, number1);
        } else {
          this.updateDisplay(number1, number2);
        }
      };
    });
  }

  updateDisplay(value1, value2) {
    const range = this.querySelector('input[type=range]');
    const priceSlideRangeContainer = this.querySelector('.facets__price--slide');
    const max = range.max;
    const width = priceSlideRangeContainer.clientWidth;

    const leftSpace = (parseInt(value1) / parseInt(max)) * width + 'px';
    const rightSpace = width - (parseInt(value2) / parseInt(max)) * width + 'px';

    if (leftSpace == 'NaNpx') {
      priceSlideRangeContainer.style.setProperty('--left-space', '10px');
    } else {
      priceSlideRangeContainer.style.setProperty('--left-space', leftSpace);
      setTimeout(() => {
        if (window.location.search.split('filter.v.price.lte=')[1] == 0) {
          priceSlideRangeContainer.style.setProperty('--left-space', '0px');
          priceSlideRangeContainer.querySelector('.filter__price_min').value = priceSlideRangeContainer
            .querySelector('.filter__price_min')
            .getAttribute('min');
          priceSlideRangeContainer.querySelector('.tooltip-value').textContent = priceSlideRangeContainer
            .querySelector('.filter__price_min')
            .getAttribute('min');
        }
      }, 1000);
    }

    priceSlideRangeContainer.style.setProperty('--right-space', '0px');
  }
}

customElements.define('custom-price-range', CustomPriceRange);

document.addEventListener('DOMContentLoaded', function () {
  window.mainPriceRangeUpdate();
});
window.updatePriceRange = function (clearFilter) {
  document.querySelectorAll('.filter__price_min').forEach((element) => {
    if (element.value == 0) {
      element.value =
        window.location.search.split('filter.v.price.lte=').length > 1
          ? window.location.search.split('filter.v.price.lte=')[1].split('&')[0]
          : 2;
    }

    document.querySelectorAll('.tooltip-value').forEach((tooltip) => {
      tooltip.textContent = element.value;
    });
  });

  document.querySelectorAll('.filter__price_max').forEach((element) => {
    document.querySelectorAll('[name="filter.v.price.lte"]').forEach((filterPriceLte) => {
      filterPriceLte.value = filterPriceLte.max;
      filterPriceLte.setAttribute('value', filterPriceLte.max);
    });
  });

  const minPrices = document.querySelectorAll('.filter__price_min');
  const maxPrices = document.querySelectorAll('.filter__price_max');
  const customPriceRanges = document.querySelectorAll('custom-price-range');

  customPriceRanges.forEach((customPriceRange, index) => {
    const minPrice = minPrices[index]?.value;
    const maxPrice = maxPrices[index]?.value;

    if (minPrice !== undefined && maxPrice !== undefined) {
      customPriceRange.updateDisplay(minPrice, maxPrice);
    }
  });

  if (clearFilter) {
    document.querySelectorAll('.filter__price_min').forEach((input) => {
      input.value = 2;
      input.closest('.facets__price--slide').style.setProperty('--left-space', '15px');
    });
  }
};

window.mainPriceRangeUpdate = function () {
  const intervalId = window.setInterval(function () {
    window.updatePriceRange();
    // console.log('update');
    setTimeout(() => {
      clearInterval(intervalId);
    }, 5000);
  }, 600);
};
window.mainPriceRangeReset = function (clearFilter) {
  const intervalId2 = window.setInterval(function () {
    window.updatePriceRange(clearFilter);
    // console.log('reset');
    setTimeout(() => {
      clearInterval(intervalId2);
    }, 2000);
  }, 500);
};
